$( function() {
	$('nav.main').find('a[data-noclick]').on('click', function(e) {
		e.preventDefault();
		$(this).closest('li').toggleClass('active');
	});

	$('nav.main').on('click', 'a.close', function(e) {
		e.preventDefault();
		$(this).closest('li').removeClass('active');
	});

	$('nav.main').find('ul ul').append($('<a class="close"><i class="fal fa-times"></i></a>'));
});